// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-rise -> price-brothers-rise -> cypress-at-lewisville-apartment-homes
// Generated: 2026-11-03T23:00:59.437Z
// Counts: 1 design, 82 content, 11 slot group, 3 collection binding, 7 section, 2 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing, Pets, and Resident Information</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Cypress at Lewisville Apartment Homes is a gated apartment community at 2436 S. Valley Parkway in Lewisville, TX, with attached garages available in select homes. The community is managed by Price Brothers Management, a family-owned company that has been managing apartment homes since 1922.</p><p>Kitchens feature stainless steel appliances, granite countertops with tile backsplashes, and an island with a smooth-top range. Outside your door, you’ll find a resort-style pool, a 24-hour fitness center, a clubhouse with a coffee bar, and an on-site bark park.</p><p>Browse our <a class=\"richtext-link\" href=\"/floor-plans\"><u>floor plans</u></a>, explore our <a class=\"richtext-link\" href=\"/amenities\"><u>amenities</u></a>, or <a class=\"richtext-link\" href=\"/schedule-a-tour\"><u>schedule a tour</u></a> of Cypress at Lewisville Apartment Homes today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentcafe-chatbot.background_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "tabbedcallouts.panel1_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_gallery_blurb"
  },
  "tabbedcallouts.panel2_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "tabbedcallouts.panel3_body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_company_icon"
  },
  "2-bedrooms-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>2-Bedroom Apartments in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "2-bedrooms-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>2 Bedrooms</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Our commitment to accessible living at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Accessibility</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet-Friendly Apartments in Lewisville, TX</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities at Cypress at Lewisville</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Apartment Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Start your application for <span data-type=\"field-token\" data-field=\"property_name\"></span> in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apply Now</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Cypress at Lewisville Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Questions? Our Leasing </h2><h2>Team Can Help</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featured-floor-plan-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>A Closer Look At Our Showcase Layout at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featured-floor-plan-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Featured Floor Plan</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>1, 2 &amp; 3-Bedroom Apartments in Lewisville, TX</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>21 Floor Plans up to </h2><h2>1,394 Square Feet</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Cypress at Lewisville Apartment Homes Photo Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Granite Kitchens, Cabanas and a Bark Park</h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Cypress at Lewisville Apartment Homes in Lewisville, TX</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover modern living at Eastpark with in-unit laundry. Enjoy ultimate convenience in Denton, TX, where comfort meets stylish amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/poolside-cabanas-garland-tx-apartments::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover apartments with poolside cabanas in Garland, TX. Luxury living with resort-style amenities is waiting for you.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Denton, TX</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/poolside-cabanas-garland-tx-apartments::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Poolside Cabanas in Garland TX Apartments</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartment Site Map in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span>,&nbsp;<span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interactive Map</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments Near Music City Mall in Lewisville, TX</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Shopping, Dining, Parks and Commuting Near Cypress at Lewisville</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pep-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Preferred Employer Program at Cypress at Lewisville Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pep-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Savings for Local Employees</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pep-intro.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Cypress at Lewisville Apartment Homes partners with select Lewisville, TX area employers through the Preferred Employer Program, offering qualifying employees savings on their new home. Team members from participating organizations may be eligible for reduced fees or other move-in incentives. <a class=\"richtext-link\" href=\"/contact-us\">Contact our leasing office</a> to confirm whether your employer participates before you apply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepbenefits.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Exclusive Perks for Preferred Employers</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepbenefits.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepcalltoaction.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Take the next step toward calling <span data-type=\"field-token\" data-field=\"property_name\"></span> home — apply today and enjoy the benefits of our exclusive discount program!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepcalltoaction.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to Claim Your Benefits?</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepcalltoaction.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepemployers.footnote": {
    "overrideType": "VALUE",
    "customValue": "<p><em>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</em></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepemployers.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Preferred Employer Partners</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "pepemployers.list": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Hospital Employees</p></li><li><p>Kubota</p></li><li><p>ISD Employees -- Teachers &amp; Administrators</p></li><li><p>Chase Bank</p></li><li><p>All City Employees</p></li><li><p>Active Military</p></li><li><p>Airline Employees</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Learn about pet-friendly living at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span> in&nbsp;<span data-type=\"field-token\" data-field=\"property_address_city\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet Policy at Cypress at Lewisville</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p>Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Review how <span data-type=\"field-token\" data-field=\"property_name\"></span> protects your personal information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Privacy Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Access your resident portal and community resources at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Resident Access</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>See what residents say about life at&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reviews</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule a Tour at Cypress at Lewisville Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Visit Cypress at Lewisville Apartment Homes</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Cypress at Lewisville Apartment Homes is part of the Price Brothers Management portfolio of communities built and managed across North Texas. If Cypress at Lewisville Apartment Homes does not have the floor plan or location you need, sister communities such as Ovation at Lewisville Apartment Homes, Creekview Apartments, The Clairborne Apartment Homes, and Wade Crossing Apartment Homes offer additional options in the area.</p><p>Explore each community's floor plans, amenities, and pricing directly on this page, or <a class=\"richtext-link\" href=\"/contact-us\"><u>contact Cypress at Lewisville Apartment Homes</u></a> if you have questions about availability.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Price Brothers Communities Near Cypress at Lewisville Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>More Price Brothers </h2><h2>Communities in North Texas</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Navigate all pages on the <span data-type=\"field-token\" data-field=\"property_name\"></span> website</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Sitemap</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel1_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Designed For Modern Luxury</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel2_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Resort-Style Living, Every Day</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.panel3_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Close to TX-121, I-35E and DFW Airport</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>We appreciate your interest in&nbsp;<span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thank You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tours of Cypress at Lewisville Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Preview Your Apartment Online</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Cypress at Lewisville Apartment Homes is a pet-friendly, gated community in Lewisville, TX, with an on-site bark park, a resort-style pool with private cabanas, and a 24-hour fitness center. The clubhouse includes a coffee bar and business center. Outside, an outdoor kitchen with grilling stations sits next to a lounge with fireplaces and a TV, so it’s easy to make a night of it with friends. An on-call maintenance team is available when you need help.&nbsp;</p><p></p><h2><strong>Apartments with Garages in Lewisville, TX&nbsp;</strong></h2><p>Select floor plans include an attached garage, and breezeway garages and visitor parking are available throughout the community. Visit our floor plans page to see which layouts include a garage.</p><p>Ready to see it in person? <a class=\"richtext-link\" href=\"/schedule-a-tour\">Schedule a tour</a> of Cypress at Lewisville today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Looking for more information about Cypress at Lewisville Apartment Homes? Our team can answer questions about <a class=\"richtext-link\" href=\"/floor-plans\"><u>available floor plans</u></a>, lease options, <a class=\"richtext-link\" href=\"/amenities\"><u>community and apartment amenities</u></a>, or <a class=\"richtext-link\" href=\"/schedule-a-tour\"><u>scheduling a tour</u></a>.</p><p>Call us at <a class=\"richtext-link\" href=\"tel:9723673084\">(972) 367-3084</a>, visit the leasing office at 2436 S. Valley Parkway, Lewisville, TX 75067, or complete the contact form below. We look forward to hearing from you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Find answers to common questions about Cypress at Lewisville Apartment Homes, a gated community at 2436 S. Valley Parkway in Lewisville, TX. Can’t find what you need? <a class=\"richtext-link\" href=\"/contact-us\">Contact our leasing team</a>, and we’ll be happy to help. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions About Cypress at Lewisville Apartment Homes</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Cypress at Lewisville Apartment Homes offers 21 floor plans, including one-, two-, and three-bedroom apartments up to 1,394 square feet. Choose an efficient one-bedroom, or a two- or three-bedroom with room for a home office, guests, or roommates.</p><p>Every floor plan includes stainless steel appliances, granite countertops, and a kitchen island with a smooth-top range. Select floor plans add 9-foot ceilings and an attached garage.</p><p>Preview the A3 one-bedroom and B2 two-bedroom with a 360 virtual tour, or schedule a tour to see a floor plan in person.</p><p></p><h2><strong>One, Two, and Three-Bedroom Options at Cypress at Lewisville Apartment Homes</strong></h2><p></p><p>Whether you need an efficient one-bedroom layout or extra room to spread out in a two or three-bedroom apartment, Cypress at Lewisville Apartment Homes has a floor plan for your needs. Each home features stainless steel appliances, granite countertops, and a kitchen island with a smooth-top range, and residents have access to the resort-style pool, 24-hour fitness center, and clubhouse.</p><p></p><h2><strong>Spacious Three-Bedroom Apartments in Lewisville, TX</strong></h2><p></p><p>Three-bedroom apartments are hard to find in Lewisville, and Cypress at Lewisville offers them alongside our one- and two-bedroom layouts. A third bedroom gives you space for a home office, a guest room, or roommates who each want their own space. Pair it with a select floor plan that includes an attached garage, and you’ll have room for both the car and everything else.</p><p>Preview the A3 one-bedroom and B2 two-bedroom with a 360 virtual tour, or<a class=\"richtext-link\" href=\"/schedule-a-tour\"> <u>schedule a tour</u></a> of Cypress at Lewisville Apartment Homes to see a floor plan in person.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Cypress at Lewisville welcomes dogs and cats, with up to two pets per apartment. Monthly pet rent is $25 per pet. The non-refundable pet fee is $300 for one pet or $500 for two pets.</p><p>Some dog breeds are restricted, including Pit Bulls, American Staffordshire Terriers, Rottweilers, German Shepherds, Malamutes, Doberman Pinschers, Chows, Great Danes, Saint Bernards, Akitas, wolf hybrids, and any mix of these breeds. Exotic, feral, or wild animals are not permitted. Contact our leasing team for complete pet policy details.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Cypress at Lewisville Apartment Homes in the way that works best for you. Choose a guided tour with a member of our leasing team, or take a 360 virtual tour of select floor plans online. Our leasing office is located at 2436 S. Valley Parkway, Lewisville, TX 75067, with tours available during business hours.</p><p>Looking for more information first? Review our <a class=\"richtext-link\" href=\"/floor-plans\">floor plans</a> and <a class=\"richtext-link\" href=\"/amenities\">community amenities</a> before you visit.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a 360 virtual tour of select floor plans at Cypress at Lewisville Apartment Homes, including the A3 one-bedroom and B2 two-bedroom layouts, before you visit in person. Review our full list of <a class=\"richtext-link\" href=\"/floor-plans\"><u>floor plans</u></a> or <a class=\"richtext-link\" href=\"/schedule-a-tour\"><u>schedule a tour</u></a> to see more of the community.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a01024-5e19-728c-8161-78d51786e56e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and a covered patio."
      }
    }
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": 36,
    "fieldOverrides": null
  },
  "sisterproperties.community1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-e174-768e-894a-8fb47775169b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool and lounge area at a multifamily property."
      }
    }
  },
  "sisterproperties.community2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-f5ae-72e9-9b40-f9f923386738.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of an outdoor swimming pool and deck area with lounge chairs and tables."
      }
    }
  },
  "sisterproperties.community3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-fc0b-754d-a071-1b52cc3e86b9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Balcony view of apartment buildings and parking lot"
      }
    }
  },
  "sisterproperties.community4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a1650c-a4a0-7458-8346-e976ad048c66.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment buildings with manicured lawns and trees."
      }
    }
  },
  "tabbedcallouts.bg_pattern": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167598/01a17eb3-e87e-762a-a776-fea06b73b32d.webp"
      },
      "tile_size": {
        "type": "VALUE",
        "customValue": "700"
      },
      "overlay_opacity": {
        "type": "VALUE",
        "customValue": "85"
      }
    }
  },
  "tabbedcallouts.panel2_image": {
    "sourceIndex": 40,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "galleryapartments.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_8f3c1934222992b2c3e00734",
      "ec_b091a53ca9d7ea9370f82976",
      "ec_9e034df2784f8a336dacf7d6",
      "ec_d2e6601f93a4a594bf09026d",
      "ec_5709815e26e0076f3ee67d31",
      "ec_8d377f64c633df41f26cbe8d",
      "ec_b349641cf6f1a217eb7cf16d",
      "ec_182e44c0342995ac9136d144",
      "ec_dac8265533ee8afa54441579",
      "ec_29e88b5d91545be7f17bdd25",
      "ec_0d39453bf690eabdaed83fe4",
      "ec_c04e7a98a22f4aa5a8c1403e",
      "ec_8bffb24d058f229a20922ac1",
      "ec_44f6a7636c9242f4c76b1a83",
      "ec_c4c757688a3826576ca1cf6b",
      "ec_e2bc98205eb41bef620553cd",
      "ec_f1cff76d5212d48d2714e54b",
      "ec_7a36b4342dd07df036ec6d11",
      "ec_4ef55538e76a0d0108b23ceb",
      "ec_f456dcf389f10429a178c554",
      "ec_5c823c61d405606a33625c72",
      "ec_1e3e1ab3771f5c93af503e38",
      "ec_f6e7448519f68eff1a4ff00e",
      "ec_21098d0a134916ba3bff6c1a",
      "ec_7c8a2765bb9974a6ba5bd365",
      "ec_69706df32daa5fa2037fb919",
      "ec_da53fe9e712cf4e871191b44",
      "ec_7b8fc1451369ab0709a4b68f"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallerycommunity.images": {
    "limit": null,
    "hiddenIds": [
      "ec_ae115902baafe18bb8a09b3b"
    ],
    "orderedIds": [
      "ec_ae115902baafe18bb8a09b3b",
      "ec_24c9bc01437c8039277ed4e3",
      "ec_d9812fdf9c90eca95f9b3ab5",
      "ec_4a1f6a505a331fb5d452fd84",
      "ec_60497a9e80a4284f5cffc33e",
      "ec_d7e64a270cc41a808ebd2e8c",
      "ec_3ac47f3edb164961cde96ca7",
      "ec_6f5a0c76d57c64919f88f09e",
      "ec_a1f5170a07fbf24c3148c26a",
      "ec_79789068b4b2765e67b77b8a",
      "ec_abdec8ab1b9aadfdbc7ed03e",
      "ec_00c8782b338de658210afb10",
      "ec_cdd2acf65df9cfb7f6db6bb0",
      "ec_cfe3ba85f06d7236b2ff18ce",
      "ec_c1a771f3b55ee9d292e3f879",
      "ec_28311eb92fbff9e4d60a9950"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "photogallery.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_24c9bc01437c8039277ed4e3",
      "ec_d9812fdf9c90eca95f9b3ab5",
      "ec_60497a9e80a4284f5cffc33e",
      "ec_4a1f6a505a331fb5d452fd84",
      "ec_ae115902baafe18bb8a09b3b",
      "ec_d7e64a270cc41a808ebd2e8c",
      "ec_6f5a0c76d57c64919f88f09e",
      "ec_3ac47f3edb164961cde96ca7",
      "ec_a1f5170a07fbf24c3148c26a",
      "ec_00c8782b338de658210afb10",
      "ec_79789068b4b2765e67b77b8a",
      "ec_abdec8ab1b9aadfdbc7ed03e",
      "ec_cfe3ba85f06d7236b2ff18ce",
      "ec_28311eb92fbff9e4d60a9950",
      "ec_c1a771f3b55ee9d292e3f879",
      "ec_b091a53ca9d7ea9370f82976",
      "ec_9e034df2784f8a336dacf7d6",
      "ec_5709815e26e0076f3ee67d31",
      "ec_d2e6601f93a4a594bf09026d",
      "ec_8d377f64c633df41f26cbe8d",
      "ec_8f3c1934222992b2c3e00734",
      "ec_b349641cf6f1a217eb7cf16d",
      "ec_182e44c0342995ac9136d144",
      "ec_29e88b5d91545be7f17bdd25",
      "ec_0d39453bf690eabdaed83fe4",
      "ec_8bffb24d058f229a20922ac1",
      "ec_c04e7a98a22f4aa5a8c1403e",
      "ec_44f6a7636c9242f4c76b1a83",
      "ec_5c823c61d405606a33625c72",
      "ec_1e3e1ab3771f5c93af503e38",
      "ec_e2bc98205eb41bef620553cd",
      "ec_c4c757688a3826576ca1cf6b",
      "ec_4ef55538e76a0d0108b23ceb",
      "ec_7a36b4342dd07df036ec6d11",
      "ec_f1cff76d5212d48d2714e54b",
      "ec_f456dcf389f10429a178c554",
      "ec_dac8265533ee8afa54441579",
      "ec_21098d0a134916ba3bff6c1a",
      "ec_f6e7448519f68eff1a4ff00e",
      "ec_7c8a2765bb9974a6ba5bd365",
      "ec_69706df32daa5fa2037fb919",
      "ec_da53fe9e712cf4e871191b44",
      "ec_7b8fc1451369ab0709a4b68f",
      "ec_cdd2acf65df9cfb7f6db6bb0"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "_section.block:apartment-sync-map": {
    "properties": {
      "paddingTop": "15px",
      "paddingRight": "15px",
      "paddingBottom": "15px",
      "paddingLeft": "15px",
      "backgroundColor": "#ffffff"
    }
  },
  "propertyoverview.pre_title": {
    "properties": {
      "fontWeight": "600"
    }
  }
};
